import moment from "moment";
import { LoadState } from "../../constants/enums";
import { STANDARD_APP_DATE_FORMAT } from "../../constants/constants";
import { IServiceItem } from "../service";

export interface ILeadsState {
  list: {
    list: ILead[];
    totalRecords: number;
    loading: LoadState;
    error: string | null;
  };
  lead: {
    data: ILead;
    loading: LoadState;
    error: string | null;
  };
  generalHistory: {
    list: IGeneralHistory[];
    loading: LoadState;
  };
  followUpHistory: {
    list: IFollowUpHistory[];
    loading: LoadState;
    error: string | null;
    totalRecords: number;
  };
  companyLeads: {
    list: ILead[];
    totalRecords: number;
    loading: LoadState;
    error: string | null;
  };
  recordCounts: {
    list: ILeadStatusCount[];

    loading: LoadState;
  };
}

export interface ILead {
  leads_uuid: string;
  lead_code: string;
  reference_code: string,
  lead_type:string;
  name: string;
  customer_name?: string; // Add customer_name field
  industry_type: string;
  alternate_industry_type?: string;
  customer_type: "";
  contact_number: string;
state: string;
  email: string;
  email_id?: string; // Add email_id field
  city: string;
  company_name: string;
  representative_name: string;
  representative_email: string;
  representative_contact: string;
  designation: string;
  alternate_contact: string;
  visited_date: string;
  function_date: string;
  followup_date: string;
  followup_time_slot: string | null;
  next_followup_date: string;
  company_outlet_uuid: string | null;
  company_outlet_name: string | null;
  event_type: string;
  event_time: string;
  event_time_uuid: string;
  number_of_guests: number;
  preferred_venue: string;
  preferred_venue_uuid: string;
  color_coding_type: string;
  fleet_size:string

  call_status:string

  communication_type:string

  first_attempt_of_call?: string;

  commercials: {
    description: string[];
    value: string[];
  }[];
  description: string;
  status:
    | "PENDING"
    | "ENGAGED"
    | "DEAD_LEAD"
    | "DEAL"
    | "POSTPONED"
    | "PROSPECT"
    | "ONGOING"
    | "INACTIVE"
    | "DELETED"
    | "REACH_OUT"
    | "NEGOTIATION"
    | "ORDER"
    | "DEAL_CLOSED";
  created_by_uuid: string;
  created_by_name: string;
  modified_by_uuid: string;
  modified_by_name: string;
  handled_by_employee: string;
  handled_by_employee_uuid: string;
  create_ts: string;
  insert_ts: string;
  whatsapp_status: string | null;
  remarks: string | null;
  event_type_uuid: string;
  customer_type_uuid: string;
  source_of_interaction: string;

  deal_type?: "MONTHLY_BUSINESS_GUARANTEE" | "SLABWISE_COMMERCIALS" | "REVENUE_SHARING" | "";
  live_date?: string; 
  api_integration?: number;
  signatory_name?: string;
  leads_contact_number?: string;
  leads_email?: string;
  signatory_remark?: string;

  proposal_json?: any;

  dynamic_field?: Array<{
    field_name: string;
    field_type: string;
    field_value: string | number | null;
  }>;
  [key: string]: any; // Allow any additional properties
}

export const initialLead: ILead = {
  leads_uuid: "",
  lead_code: "",
  reference_code: "",
  lead_type:"SUSPECT",
  name: "",
  industry_type: "",
  alternate_industry_type: "",
  customer_type: "",
  contact_number: "",
  email: "",
  state: "",
  city: "",
  company_name: "",
  representative_name: "",
  company_outlet_uuid: "",
  company_outlet_name: "",
  representative_email: "",
  representative_contact: "",
  designation: "",
  alternate_contact: "",
  visited_date: "",
  function_date: "",
  followup_date: "",
  followup_time_slot: null,
  next_followup_date: "",
  event_type: "",
  event_time: "",
  event_time_uuid: "",
  number_of_guests: 0,
  preferred_venue: "",
  preferred_venue_uuid: "",
  commercials: [
    {
      description: [""],
      value: [""],
    },
  ],
  description: "",
  status: "ONGOING",
  color_coding_type: "",
  call_status: "CONNECTED",
  communication_type:"First Call",
  fleet_size:"10-1000",
  first_attempt_of_call: "",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  handled_by_employee: "",
  handled_by_employee_uuid: "",
  create_ts: new Date().toISOString(),
  insert_ts: new Date().toISOString(),
  whatsapp_status: null,
  remarks: null,
  event_type_uuid: "",
  customer_type_uuid: "",
  source_of_interaction: "",
  proposal_json: [],
  deal_type: "",
};

export const initialLeadState: ILeadsState = {
  list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  lead: {
    data: initialLead,
    loading: LoadState.NotLoaded,
    error: null,
  },
  generalHistory: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  followUpHistory: {
    list: [],
    loading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
  },
  companyLeads: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  recordCounts: {
    list: [],

    loading: LoadState.NotLoaded,
  },
};

export interface ILeadStatusCount {
  [key: string]: number;
}

export interface IGeneralHistory {
  insert_ts: string;
  [key: string]: any;
}

export interface IFollowUpHistory {
  communication_type: string | null;
  call_status: "CONNECTED" | "NOT CONNECTED";
  followup_date: string;
  followup_time_slot: string | null;
  remarks: string | null;
  insert_ts: string;
}

export interface IMultipleEvent {
  leads_uuid: string | null;
  event_type: string;
  event_uuid: string;
  event_time: string;
  event_time_uuid: string;
  preferred_venue: string;
  preferred_venue_uuid: string;
  // Event-specific fields (independent per row)
  booking_date: string | null;
  function_month?: string | null;
  function_date?: string | null;
  followup_date?: string | null;
  status: string;
  actual_status: string;
  drive_status_uuid: string;
  service?: IServiceItem[] | null;
  number_of_rooms: number | null;
  number_of_guests: number | null;

  // Conditional fields
  cancellation_dead_reason?: string | null;
  payment_mode?: "BILL_TO_COMPANY" | "DIRECT" | null;
  other_event_name?: string | null;
}

// Dynamic form fields data structure
// Key: field_uuid (form_labels_uuid)
// Value: Object with field_name and value
export interface IExtras {
  [field_uuid: string]: {
    field_name: string;
    value: string | number | boolean | string[] | null | undefined;
  };
}

export const initialMultipleEvent: IMultipleEvent = {
  leads_uuid: null,
  event_type: "",
  event_uuid: "",
  event_time: "",
  event_time_uuid: "",
  preferred_venue: "",
  preferred_venue_uuid: "",
  booking_date: null,
  status: "ONGOING",
  actual_status: "",
  drive_status_uuid: "",
  number_of_rooms: null,
  number_of_guests: null,
};